webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(33);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(32);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(31);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(24);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _goods = __webpack_require__(25);
	
	var _goods2 = _interopRequireDefault(_goods);
	
	var _ratings = __webpack_require__(27);
	
	var _ratings2 = _interopRequireDefault(_ratings);
	
	var _seller = __webpack_require__(28);
	
	var _seller2 = _interopRequireDefault(_seller);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	var app = _vue2.default.extend(_App2.default);
	
	var router = new _vueRouter2.default({
	  linkActiveClass: 'active'
	});
	
	router.map({
	  '/goods': {
	    component: _goods2.default
	  },
	  '/ratings': {
	    component: _ratings2.default
	  },
	  '/seller': {
	    component: _seller2.default
	  }
	});
	
	router.start(app, '#app');
	
	router.go('/goods');

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(26);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERR_OK = 0;
	exports.default = {
	  data: function data() {
	    return {
	      seller: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$http.get('static/data.json').then(function (response) {
	      response = response.body;
	      if (response.errno !== ERR_OK) {
	        _this.seller = response.seller;
	      }
	    });
	  },
	
	  components: {
	    'v-header': _header2.default
	  }
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _betterScroll = __webpack_require__(8);
	
	var _betterScroll2 = _interopRequireDefault(_betterScroll);
	
	var _shopcart = __webpack_require__(29);
	
	var _shopcart2 = _interopRequireDefault(_shopcart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERR_OK = 0;
	exports.default = {
	  props: {
	    seller: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      goods: [],
	      listHeight: [],
	      scrollY: 0
	    };
	  },
	
	  computed: {
	    currentIndex: function currentIndex() {
	      for (var i = 0; i < this.listHeight.length; i++) {
	        var height1 = this.listHeight[i];
	        var height2 = this.listHeight[i + 1];
	        if (!height2 || this.scrollY >= height1 && this.scrollY < height2) {
	          return i;
	        }
	      }
	      return 0;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
	    this.$http.get('static/data.json').then(function (response) {
	      response = response.body;
	      console.log(response);
	      if (response.errno !== ERR_OK) {
	        _this.goods = response.goods;
	        _this.$nextTick(function () {
	          _this._initScroll();
	          _this._calculateHeight();
	        });
	        _this._initScroll();
	      }
	    });
	  },
	
	  methods: {
	    selectMenu: function selectMenu(index, event) {
	      if (!event._constructed) {
	        return;
	      }
	      var foodList = this.$els.foodsWrapper.getElementsByClassName('food-list-hook');
	      var el = foodList[index];
	      this.foodsScroll.scrollToElement(el, 300);
	    },
	    _initScroll: function _initScroll() {
	      var _this2 = this;
	
	      this.menuScroll = new _betterScroll2.default(this.$els.menuWrapper, {
	        click: true
	      });
	      this.foodsScroll = new _betterScroll2.default(this.$els.foodsWrapper, {
	        probeType: 3
	      });
	      this.foodsScroll.on('scroll', function (pos) {
	        _this2.scrollY = Math.abs(Math.round(pos.y));
	      });
	    },
	    _calculateHeight: function _calculateHeight() {
	      var foodList = this.$els.foodsWrapper.getElementsByClassName('food-list-hook');
	      var height = 0;
	      this.listHeight.push(height);
	      for (var i = 0; i < foodList.length; i++) {
	        var item = foodList[i];
	        height += item.clientHeight;
	        this.listHeight.push(height);
	      }
	    }
	  },
	  components: {
	    shopcart: _shopcart2.default
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _star = __webpack_require__(30);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        seller: {
	            type: Object
	        }
	    },
	    data: function data() {
	        return {
	            detailShow: false
	        };
	    },
	
	    methods: {
	        showDetail: function showDetail() {
	            this.detailShow = true;
	        },
	        hideDetail: function hideDetail() {
	            this.detailShow = false;
	        }
	    },
	    created: function created() {
	        this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
	    },
	
	    components: {
	        star: _star2.default
	    }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    selectFoods: {
	      type: Array,
	      default: function _default() {
	        return [{
	          price: 50,
	          count: 1
	        }];
	      }
	    },
	    deliveryPrice: {
	      type: Number,
	      default: 0
	    },
	    minPrice: {
	      type: Number,
	      default: 0
	    }
	  },
	  computed: {
	    totalPrice: function totalPrice() {
	      var total = 0;
	      this.selectFoods.forEach(function (food) {
	        total += food.price * food.count;
	      });
	      return total;
	    },
	    totalCount: function totalCount() {
	      var count = 0;
	      this.selectFoods.forEach(function (food) {
	        count += food.count;
	      });
	      return count;
	    },
	    payDesc: function payDesc() {
	      if (this.totalPrice === 0) {
	        return '\uFFE5' + this.minPrice + '\u5143\u8D77\u9001';
	      } else if (this.totalPrice < this.minPrice) {
	        var diff = this.minPrice - this.totalPrice;
	        return '\u8FD8\u5DEE\uFFE5' + diff + '\u5143\u8D77\u9001';
	      } else {
	        return '去结算';
	      }
	    },
	    payClass: function payClass() {
	      if (this.totalPrice < this.minPrice) {
	        return 'not-enough';
	      } else {
	        return 'enough';
	      }
	    }
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var LENGTH = 5;
	var CLS_ON = 'on';
	var CLS_HALF = 'half';
	var CLS_OFF = 'off';
	exports.default = {
	  props: {
	    size: {
	      type: Number
	    },
	    score: {
	      type: Number
	    }
	  },
	  computed: {
	    starType: function starType() {
	      return 'star-' + this.size;
	    },
	    itemClasses: function itemClasses() {
	      var result = [];
	      var score = Math.floor(this.score * 2) / 2;
	      var hasDecimal = score % 1 !== 0;
	      var integer = Math.floor(score);
	      for (var i = 0; i < integer; i++) {
	        result.push(CLS_ON);
	      }
	      if (hasDecimal) {
	        result.push(CLS_HALF);
	      }
	      while (result.length < LENGTH) {
	        result.push(CLS_OFF);
	      }
	      return result;
	    }
	  }
	};

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = " <div> <v-header :seller=seller> v-header </v-header> <div class=\"tab border-1px\"> <div class=tab-item> <a v-link=\"{path:'/goods'}\" href=\"\">商品</a> </div> <div class=tab-item> <a v-link=\"{path:'/ratings'}\" href=\"\">评论</a> </div> <div class=tab-item> <a v-link=\"{path:'/seller'}\" href=\"\">商家</a> </div> </div> <router-view :seller=seller></router-view> </div> ";

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = " <div class=goods> <div class=menu-wrapper v-el:menu-wrapper> <ul> <li v-for=\"item in goods\" class=menu-item :class=\"{'current':currentIndex===$index}\" @click=selectMenu($index,$event)> <span class=text> <span class=icon :class=classMap[item.type] v-show=\"item.type>0\"></span>{{item.name}} </span> </li> </ul> </div> <div class=foods-wrapper v-el:foods-wrapper> <ul> <li class=\"food-list food-list-hook\" v-for=\"item in goods\"> <h1 class=title>{{item.name}}</h1> <ul> <li class=\"food-item border-1px\" v-for=\"food in item.foods\"> <div class=icon> <img :src=food.icon alt=\"\"> </div> <div class=content> <h2 class=name>{{food.name}}</h2> <p class=desc>{{food.description}}</p> <div class=extra> <span class=count>月售{{food.sellCount}}</span><span>好评率{{food.rating}}</span> </div> <div class=price> <span class=now>￥{{food.price}}</span><span v-show=food.oldPrice>￥{{food.oldPrice}}</span> </div> </div> </li> </ul> </li> </ul> </div> <shopcart :delivery-price=seller.deliveryPrice :min-price=seller.minPrice></shopcart> </div> ";

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = " <div class=header> <div class=content-wrapper> <div class=avatar> <img width=64 height=64 :src=seller.avatar> </div> <div class=content> <div class=title> <span class=brand></span> <span class=name>{{seller.name}}</span> </div> <div class=description> {{seller.description}}/{{seller.deliveryTime}}分钟送达 </div> <div v-if=seller.supports class=support> <span class=icon :class=classMap[seller.supports[0].type]></span> <span class=text>{{seller.supports[0].description}}</span> </div> </div> <div class=support-count v-if=seller.supports @click=showDetail> <span class=count>{{seller.supports.length}}</span> <i class=icon-keyboard_arrow_right></i> </div> </div> <div class=bulletin-wrapper @click=showDetail> <span class=bulletin-title></span> <span class=bulletin-text>{{seller.bulletin}}</span> <i class=icon-keyboard_arrow_right></i> </div> <div class=background> <img :src=seller.avatar width=100% height=100% alt=\"\"> </div> <div class=detail v-show=detailShow transition=fade> <div class=\"detail-wrapper clearfix\"> <div class=detail-main> <h1 class=name>{{seller.name}}</h1> <div class=star-wrapper> <star :size=48 :score=seller.score></star> </div> <div class=title> <div class=line></div> <div class=text>优惠信息</div> <div class=line></div> </div> <ul class=supports v-if=seller.supports> <li class=support-item v-for=\"item in seller.supports\"> <span class=icon :class=classMap[seller.supports[$index].type]></span> <span class=text>{{seller.supports[$index].description}}</span> </li> </ul> <div class=title> <div class=line></div> <div class=text>商家公告</div> <div class=line></div> </div> <div class=bulletin> <p class=content>{{seller.bulletin}}</p> </div> </div> </div> <div class=detail-close> <i class=icon-close @click=hideDetail transition=fade></i> </div> </div> </div> ";

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = " <div>ratings</div> ";

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = " <div>seller</div> ";

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = " <div class=shopcart> <div class=content> <div class=content-left> <div class=logo-wrapper> <div class=logo :class=\"{'highlight':totalCount>0}\"> <i class=icon-shopping_cart :class=\"{'highlight':totalCount>0}\"></i> </div> <div class=num v-show=\"totalCount>0\">{{totalCount}}</div> </div> <div class=price :class=\"{'highlight':totalCount>0}\">￥{{totalPrice}}</div> <div class=desc>另需配送费￥{{deliveryPrice}}元</div> </div> <div class=content-right> <div class=pay :class=payClass>{{payDesc}}</div> </div> </div> </div> ";

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = " <div class=star :class=starType> <span v-for=\"itemClass in itemClasses\" :class=itemClass class=star-item track-by=$index></span> </div> ";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(10)
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(17)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(11)
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(18)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(12)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(19)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(13)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(20)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(14)
	__vue_script__ = __webpack_require__(5)
	__vue_template__ = __webpack_require__(21)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(15)
	__vue_script__ = __webpack_require__(6)
	__vue_template__ = __webpack_require__(22)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(16)
	__vue_script__ = __webpack_require__(7)
	__vue_template__ = __webpack_require__(23)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.b729bf920dd2eb014eb7.js